import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProfileType } from '@capital-access/profiles/common';
import { PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE } from '../../models/constants';

@Component({
  selector: 'ca-company-profiles-icon',
  templateUrl: './company-profiles-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CompanyProfilesIconComponent {
  localizationScope = PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE;

  @Input() iconClass: string = 'ms-1 align-bottom';
  @Input() iconSizeClass: string = 'f-i-sm';
  @Input() crmId: number | null | undefined;
  @Input() prId: number | null | undefined;
  @Input() container: string = 'target';
  @Input() profileType: ProfileType = ProfileType.Institution;

  get isBdOnly() {
    return !this.crmId && this.prId;
  }

  getIconClass() {
    return this.crmId ? (this.prId ? 'f-i-mixed-non-primary' : 'f-i-crm') : '';
  }

  getIconTitle() {
    if (this.profileType === ProfileType.Fund) {
      return this.getFundIconTitle();
    }
    return this.getInstitutionIconTitle();
  }

  getInstitutionIconTitle() {
    return this.crmId ? (this.prId ? 'institutionBdCrmIconTitle' : 'institutionCrmOnlyIconTitle') : null;
  }

  getFundIconTitle() {
    return this.crmId ? (this.prId ? 'fundBdCrmIconTitle' : 'fundCrmOnlyIconTitle') : null;
  }
}
